var _circle, _circle2, _path, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRolesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1699,
    cy: 18.4862,
    r: 17.5,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1704,
    cy: 11.5926,
    r: 4.13183,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4824 21.9836C12.4824 18.8423 15.0289 16.2958 18.1702 16.2958C21.3115 16.2958 23.858 18.8423 23.858 21.9836C23.858 22.2488 23.8399 22.5099 23.8047 22.7655H24.8128C24.8427 22.509 24.858 22.2481 24.858 21.9836C24.858 18.29 21.8638 15.2958 18.1702 15.2958C14.4766 15.2958 11.4824 18.29 11.4824 21.9836C11.4824 22.2481 11.4978 22.509 11.5276 22.7655H12.5357C12.5006 22.5099 12.4824 22.2488 12.4824 21.9836Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7554,
    cy: 27.6791,
    r: 1.81592,
    transform: "rotate(90 24.7554 27.6791)",
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1694,
    cy: 27.6791,
    r: 2.31592,
    transform: "rotate(90 18.1694 27.6791)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5835,
    cy: 27.6791,
    r: 1.81592,
    transform: "rotate(90 11.5835 27.6791)",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesIcon);
export default __webpack_public_path__ + "static/media/roles-icon.2311b9db02be7186bad4e367c293a5f2.svg";
export { ForwardRef as ReactComponent };